import { Text } from '@radix-ui/themes';

export interface FieldErrorProps {
  message?: string;
  align?: 'left' | 'center' | 'right';
}

export function FieldError({ message, align }: FieldErrorProps) {
  if (!message) return null;

  return (
    <Text size="1" color="crimson" align={align}>
      {message}
    </Text>
  );
}
